import useReveal from "../hooks/useReveal";
import { Check, X } from "lucide-react";

const ROWS = [
    { label: "Live shipment visibility", us: true, fwd: false, vis: true },
    { label: "Independent advisory (not paid by carriers)", us: true, fwd: false, vis: false },
    { label: "Freight invoice audit & cost recovery", us: true, fwd: false, vis: false },
    { label: "Procurement benchmarking", us: true, fwd: false, vis: false },
    { label: "Operational execution support", us: true, fwd: true, vis: false },
    { label: "Continuous improvement programme", us: true, fwd: false, vis: false },
    { label: "Single view across all forwarders", us: true, fwd: false, vis: true },
    { label: "Built for the Australian market", us: true, fwd: false, vis: false },
];

export default function WhyUs() {
    const [ref, visible] = useReveal();
    return (
        <section
            id="why-us"
            data-testid="why-us-section"
            className="relative border-t border-white/5 py-20 sm:py-28"
        >
            <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}>
                <div className="max-w-2xl mb-12">
                    <span className="section-tag">Why WE DELVR LOGISTICS</span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-tight">
                        Most platforms stop at tracking. <br className="hidden sm:block" />
                        Most forwarders focus on execution.
                    </h2>
                    <p className="text-zinc-400 mt-5 leading-relaxed">
                        We bring strategy, control and advisory together — independent from carriers,
                        focused on closing the gaps that actually cost you money.
                    </p>
                </div>

                <div className="card-glow rounded-2xl overflow-hidden">
                    <div className="grid grid-cols-4 px-4 sm:px-6 py-4 text-xs font-mono-accent uppercase tracking-[0.16em] text-zinc-500 border-b border-white/10">
                        <div className="col-span-2 sm:col-span-1">Capability</div>
                        <div className="text-center text-cyan-300">WE DELVR LOGISTICS</div>
                        <div className="text-center hidden sm:block">Traditional forwarder</div>
                        <div className="text-center sm:hidden">Forwarder</div>
                        <div className="text-center hidden sm:block">Visibility-only platform</div>
                    </div>
                    {ROWS.map((r) => (
                        <div
                            key={r.label}
                            data-testid={`why-row-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40)}`}
                            className="grid grid-cols-4 px-4 sm:px-6 py-4 items-center border-b border-white/5 last:border-b-0 hover:bg-white/[0.02] transition-colors"
                        >
                            <div className="col-span-2 sm:col-span-1 text-sm text-zinc-200 pr-2">{r.label}</div>
                            <div className="flex justify-center">
                                <Mark on={r.us} highlight />
                            </div>
                            <div className="flex justify-center">
                                <Mark on={r.fwd} />
                            </div>
                            <div className="hidden sm:flex justify-center">
                                <Mark on={r.vis} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

function Mark({ on, highlight }) {
    if (on) {
        return (
            <span
                className={`w-7 h-7 rounded-full flex items-center justify-center ${
                    highlight
                        ? "bg-cyan-400/15 border border-cyan-400/50"
                        : "bg-white/5 border border-white/15"
                }`}
            >
                <Check size={14} className={highlight ? "text-cyan-300" : "text-zinc-400"} />
            </span>
        );
    }
    return (
        <span className="w-7 h-7 rounded-full flex items-center justify-center bg-transparent border border-white/8">
            <X size={14} className="text-zinc-700" />
        </span>
    );
}
